import * as React from "react";
import { Button, Result } from "antd";
import { node } from "prop-types";

class ErrorBoundry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("error!", error, errorInfo);
  }
  errorReload =()=> {
    window.location.reload();
    return false;
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "1.5em" }}>
          <Result
            status="500"
            title="500"
            subTitle="Oops! Something unexpected happened, we have received a notification and will be working on it"
            style={{
              fontFamily: "Mulish, sans-serif",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
            }}
            extra={
              <Button
                type="primary"
                className="btn btn-danger "
                onClick={this.errorReload}
              >
                Reload
              </Button>
            }
          />
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundry.propTypes = {
  children: node,
};

export default ErrorBoundry;
